"use strict";

var _this = this;

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.off = exports.on = void 0;

var weex_1 = require("./weex");

exports.on = function (e, t) {
  weex_1.requireModule("globalEvent").addEventListener(e, function (e) {
    var r = {
      preventDefault: function preventDefault() {
        throw new Error("does not support preventDefault");
      },
      detail: e
    };
    t.call(_this, r);
  });
}, exports.off = function (e, t) {
  weex_1.requireModule("globalEvent").removeEventListener(e, t);
};